export const outbrain = (): void => {
  // COMMENT OUT IF NEEDED TO TEST IN DEVELOPMENT
  if (process.env.NODE_ENV !== 'development') {
    const scriptId = 'outbrain-script'
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script['data-obct'] = true
    script.async = true
    script.innerHTML = `
      !function(_window, _document) {
        var OB_ADV_ID = '00f1143648783e7e4e0c1ac9d69f030173';
        if (_window.obApi) {
          var toArray = function(object) {
            return Object.prototype.toString.call(object) === '[object Array]' ? object : [object];
          };
          _window.obApi.marketerId = toArray(_window.obApi.marketerId).concat(toArray(OB_ADV_ID));
          return;
        }
        var api = _window.obApi = function() {
          api.dispatch ? api.dispatch.apply(api, arguments) : api.queue.push(arguments);
        };
        api.version = '1.1';
        api.loaded = true;
        api.marketerId = OB_ADV_ID;
        api.queue = [];
        var tag = _document.createElement('script');
        tag.async = true;
        tag.src = '//amplify.outbrain.com/cp/obtp.js';
        tag.type = 'text/javascript';
        var script = _document.getElementsByTagName('script')[0];
        script.parentNode.insertBefore(tag, script);
      }(window, document);
    `
    script.id = scriptId
    const firstScript = document.getElementsByTagName('script')[0]
    if (document.getElementById(scriptId) == null) {
      firstScript.parentNode?.insertBefore(script, firstScript)
    }
  }
}
